import { toFixedByDefault } from '@clickadilla/components/utils/to-fixed-by-default.js'

export default class FinancesStatistics {
  constructor(data) {
    this.date = data.date
    this.debit = toFixedByDefault(+data.debit)
    this.credit = toFixedByDefault(+data.credit)
    this.refundAmount = toFixedByDefault(+data.refund_amount)
    this.offsetAmount = toFixedByDefault(+data.offset_amount)
    this.invoiceAmount = toFixedByDefault(+data.invoice_amount)
  }
}
